import { StrKey } from "stellar-sdk";

import TextPicker from "components/FormComponents/TextPicker";
import { ImportMark } from "components/ImportMark";
import { useFreighter, freighterGetPublicKey } from "helpers/useFreighter";
import {Client as KuknosWallet, walletType} from '@kuknos/wallet-connect';

interface PubKeyPickerProps {
  [key: string]: any;
  placeholder?: string;
  value: string;
  onUpdate: (value: string) => void;
}

export default function PubKeyPicker({
  placeholder,
  value,
  onUpdate,
  ...props
}: PubKeyPickerProps) {
  const hasFreighter = useFreighter();


  const getSourceAccountFromKuknosExtension = ()=>{
    
    const wallet = new KuknosWallet({
      wallet_type: walletType.browser_extension,
    });
    wallet.connect()
    .then((result) => {
      onUpdate(result.data.public);
    }).catch((err) => {
      console.log('err');
      
    });
  };

  return (
    <div className="PubKeyPicker">
      <div style={{
        position: 'relative',
      }}>
        <TextPicker
          {...props}
          value={value}
          onUpdate={onUpdate}
          placeholder={
            placeholder ||
            "Example: GCEXA******6Q4UG"
          }
          validator={(value: string) => {
            if (value.startsWith("M")) {
              // TODO: remove when type is added to stellar-sdk
              // @ts-ignore
              if (!StrKey.isValidMed25519PublicKey(value)) {
                return "Muxed account address is invalid.";
              }
            } else if (!StrKey.isValidEd25519PublicKey(value)) {
              return "Public key is invalid.";
            }

            return null;
          }}
        />
        {!value && <div style={{
          position: 'absolute',
          right: 10,
          top: 5,
          cursor: 'pointer',

        }}>
          <a
            className="s-button"
            style={{
              fontSize: '0.75em',
            }}
            onClick={() => {
              getSourceAccountFromKuknosExtension();
            }}
          >
            Fetch From Kuknos Extension
          </a>
          {/* <img src="/assets/images/kuknos.png" style={{width: 25}} /> */}
        </div>}
      </div>
      
      {/* {!value && <p className="optionsTable__pair__content__note">
        <a
          className="s-button"
          onClick={() => {
            getSourceAccountFromKuknosExtension();
          }}
        >
          Fetch Source Account From Kuknos Extension
        </a>
      </p>} */}

      {hasFreighter && (
        <button
          type="button"
          onClick={() => freighterGetPublicKey(onUpdate)}
          className="s-button__icon PubKeyPicker__activator"
        >
          <ImportMark width={24} />
        </button>
      )}
    </div>
  );
}
